import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './RadioButton.styled';
import FormLabel from '@material-ui/core/FormLabel';
import { ErrorMessage } from 'components/FormFields';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';

const RadioButtonsGroup = ({
  label,
  children,
  value,
  name,
  setFieldValue,
  errors,
  touched,
  nonBool,
  row,
  disabled,
}) => {
  const classes = useStyles();

  /**
   * Handle radio button change
   * @param {object} event
   */
  const handleChange = (event) => {
    if (nonBool) {
      setFieldValue(name, event.target.value);
    } else {
      const e = event.target.value === 'true';
      setFieldValue(name, e);
    }
  };

  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel component="legend" className={classes.label}>
        {label}
      </FormLabel>
      <RadioGroup
        name={name}
        value={value}
        onChange={handleChange}
        aria-label="radio-button"
        row={row}
      >
        {children}
      </RadioGroup>
      {errors && touched && errors[name] && touched[name] && (
        <ErrorMessage style={{ marginLeft: 0 }} hasIcon={false}>
          {errors[name]}
        </ErrorMessage>
      )}
    </FormControl>
  );
};

RadioButtonsGroup.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.node,
  errors: PropTypes.object,
  children: PropTypes.node,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
};

export default RadioButtonsGroup;
